require('lodash');
window.Autolinker = require('autolinker');
require('angular');
require('restangular');

require('../app/js/modules/api.module.js');

angular.module('hjApp.ui', []);
angular.module('hjApp', ['hjApp.ui']);

require('../app/js/services/modals/modal-prompt');
require('../app/js/services/rest-default-handlers.js');
require('../app/js/filters/trust.js');
require('../app/js/filters/urls-to-links.js');

require('bootstrap/dist/css/bootstrap.css');
require('./css/survey.scss');
require('./js/controllers/show-ctrl.js');
